import { Event_interface } from "./event_interface";
import {
  EventClass,
  EventCourse,
  EventRequest
} from "../../../../domain/entities/courseEvent/courseEvent";
import http from "../../http";
import {
  ContentComment,
  Instructor
} from "../../../../domain/entities/entities";
import { wrapErrorHandler } from "../../utils/wrap_error_handler";

class _EventRepository implements Event_interface {
  async list(): Promise<EventCourse[]> {
    return wrapErrorHandler<EventCourse[]>(async () => {
      const response = await http.get("/api/decola/event/list");
      return response.data;
    });
  }

  async getEventCourse(eventID: number): Promise<EventRequest> {
    return wrapErrorHandler<EventRequest>(async () => {
      return (await http.get(`/api/decola/event/${eventID}`)).data;
    });
  }

  async enrollUser(eventClass: EventClass): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      const response = await http.post(
        `/api/decola/event/class/${eventClass.id}/enroll`
      );
      return response.data;
    });
  }

  async unEnrollUser(eventClass: EventClass): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      const response = await http.post(
        `/api/decola/event/class/${eventClass.id}/unenroll`
      );
      return response.data;
    });
  }

  async getComments(eventId: number): Promise<ContentComment[]> {
    return wrapErrorHandler<ContentComment[]>(async () => {
      const response = await http.get(`/api/decola/event/{eventId}/ratings`);
      return response.data;
    });
  }

  async confirmCheckinQrCode(token: string, date: string): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      const response = await http.post(
        `/api/decola/event/check-in/qr-code?confirmation=true&date=${date}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    });
  }

  async getInstructors(
    eventID: number,
    classID: number
  ): Promise<Instructor[]> {
    return wrapErrorHandler<Instructor[]>(async () => {
      const response = await http.get(
        `/api/decola/event/${eventID}/class/${classID}/instructors`
      );
      return response.data;
    });
  }

  async generateCertificate(eventID: number, classID: number): Promise<string> {
    return wrapErrorHandler<string>(async () => {
      const params: URLSearchParams = new URLSearchParams();

      /**
       * PRODUÇÃO
       * EventID = 1422
       * ClassID = 319
       *
       * */

      if (eventID === 1422 && classID === 319) {
        params.append("certificateDifferent", "true");
      }
      const response = await http.get(
        `/api/decola/certificate/event/${eventID}/class/${classID}`,
        { params }
      );
      return response.data.path;
    });
  }
}

export const interfaceEventRepository: Event_interface = new _EventRepository();
